<template>
  <div id="app">
    <transition name="fade-transform" mode="out-in">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    (/iphone|ipod|ipad/i.test(navigator.appVersion)) && document.addEventListener(
    'blur',
    event => {
			// 当页面没出现滚动条时才执行，因为有滚动条时，不会出现这问题
      // input textarea 标签才执行，因为 a 等标签也会触发 blur 事件
        if (
            document.documentElement.offsetHeight <=
            document.documentElement.clientHeight &&
            event.target.className !== 'mint-field-core'
            && ['input', 'textarea'].includes(event.target.localName)
        ) {
            document.body.scrollIntoView() // 回顶部
        }
    },
    true
    )
  }
}
</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-size: 0;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue